module.exports = __webpack_public_path__ + "img/logo-icon.66e57756.png";